import React, { useState, useEffect, useRef } from 'react';
import Header from "../components/header/header";
import Footer from "../components/footer/footer";
import { useLocation  } from "react-router-dom";

export default function Layout({ children, homeData }) {
  const [isGetApplePage, setIsGetApplePage] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const location = useLocation();
  const headerRef = useRef(null);
  var applePages = {
    "/apple": true,
    "/apple/enterprise/": true,
    "/apple/enterprise/applecare/": true,
    "/apple/mac-does-that/": true
  }

  const handleScroll = () => {
    if (window.scrollY > 0) {
      setIsScrolled(true);
    } else {
      setIsScrolled(false);
    } 
  }; 
  useEffect(() => {
    setIsGetApplePage(!!applePages[location.pathname]);
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [location.pathname]);

  // .header-wrapper is position: fixed, so reserve its real height here;
  // otherwise it overlaps the top of the page content (e.g. the page title bar)
  useEffect(() => {
    const header = headerRef.current;
    const wrapper = header?.querySelector('.header-wrapper');
    if (!wrapper) return;
    const syncHeight = () => { header.style.height = `${wrapper.offsetHeight}px`; };
    syncHeight();
    const observer = new ResizeObserver(syncHeight);
    observer.observe(wrapper);
    return () => observer.disconnect();
  }, []);

  return (
    <>
      <div ref={headerRef} className={`header ${isGetApplePage ? "apple-header" : ""} ${isScrolled ? 'stuck' : ''}`}>
        <Header homeData={homeData} />
      </div>
      <div className="inner-wrap">
        {children}
      </div>
      <div className="site-footer">
        <Footer homeData={homeData} />
      </div>
    </>
  )
}